import React, { useState } from "react";

import { apiRequest } from "../../utils/api";
import { useTranslation } from "react-i18next";
import { useNotification } from "../../context/notification";

import AlertDialog from "../AlertDialog";
import { Button } from "@material-ui/core";
import SendIcon from "@material-ui/icons/Send";

import styles from "./index.module.scss";

function SendgridCheck({ email }) {
  const { t } = useTranslation();
  const { addNotification } = useNotification();

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [hasBounce, setHasBounce] = useState(false);
  const [hasBlock, setHasBlock] = useState(false);

  const handleCheckSendgridStatus = async () => {
    try {
      const response = await apiRequest.get("/api/getSendGridSuppression", {
        params: { email },
      });

      const data = response?.data?.data;
      if (response.status === 200) {
        setHasBounce(data.bounces && data.bounces.length > 0);
        setHasBlock(data.blocks && data.blocks.length > 0);
        setIsDialogOpen(true);
      } else {
        addNotification(
          t("userManagement.sendgridCheckError") +
            ` (Status code: ${response.status})`,
          "error"
        );
      }
    } catch (error) {
      console.error("Error checking SendGrid status:", error);
      addNotification(t("userManagement.sendgridCheckError"), "error");
    }
  };

  const handleClearSengridSuppression = async () => {
    try {
      const response = await apiRequest.post(
        "/api/clearSendGridSuppression",
        {},
        {
          params: { email },
        }
      );

      if (response.status === 200) {
        addNotification(
          t("userManagement.sendgridSuppressionCleared"),
          "success"
        );
      } else {
        addNotification(
          t("userManagement.sendgridClearError") +
            ` (Status code: ${response.status})`,
          "error"
        );
      }
      setIsDialogOpen(false);
    } catch (error) {
      console.error("Error clearing SendGrid suppression:", error);
      addNotification(t("userManagement.sendgridClearError"), "error");
    }
  };

  return (
    <>
      <div
        className={`${styles.buttonLabel}`}
        onClick={handleCheckSendgridStatus}
      >
        <SendIcon />
        {t("userManagement.sendgridCheck")}
      </div>
      <AlertDialog
        maxWidth="xs"
        title={t("userManagement.sendgridStatus")}
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        body={
          <div className={styles.userStatus}>
            <div className={styles.statusItem}>
              <p className={styles.statusLabel}>
                {t("userManagement.bounces")}:
              </p>
              <p
                className={styles.statusValue}
                data-state={hasBounce ? "active" : "inactive"}
              >
                {hasBounce ? "Suppression exists" : "No suppression"}
              </p>
            </div>

            <div className={styles.statusItem}>
              <p className={styles.statusLabel}>
                {t("userManagement.blocks")}:
              </p>
              <p
                className={styles.statusValue}
                data-state={hasBlock ? "active" : "inactive"}
              >
                {hasBlock ? "Suppression exists" : "No suppression"}
              </p>
            </div>
          </div>
        }
        footer={
          <>
            <Button
              className={styles.button}
              style={{ color: "grey" }}
              onClick={() => {
                setIsDialogOpen(false);
              }}
            >
              {t("userManagement.cancel")}
            </Button>
            {(hasBounce || hasBlock) && (
              <Button
                className={styles.button}
                color="primary"
                onClick={handleClearSengridSuppression}
                variant="contained"
              >
                {t("userManagement.sendgridClear")}
              </Button>
            )}
          </>
        }
      />
    </>
  );
}

export default SendgridCheck;
